import type { ReactNode } from "react";

// Shared breadcrumb after the widget name, so every header subtitle reads "Name › Subtitle".
const WidgetHeaderSubtitle = ({
  testId,
  title,
  children,
}: {
  testId: string;
  title: string;
  children: ReactNode;
}) => {
  return (
    <span
      data-testid={testId}
      id={testId}
      title={title}
      className="ml-2 flex min-w-0 items-center gap-2 font-normal"
    >
      <span className="opacity-60">›</span>
      {children}
    </span>
  );
};

export default WidgetHeaderSubtitle;
